import { Checkbox, Col, Form, Row, Space, Typography } from "antd";
import { FormikProps } from "formik";
import React from "react";
import Big from "big.js";
import CustomBtn from "../../../../shared/CustomBtn/CustomBtn";
import { TimeLockOptions } from "../../../../TimelockStaking/TimelockStaking";

import * as style from "../StepsStyle.module.scss"

const mappedTimeLockOptions = Object.values(TimeLockOptions);

type Props = {
  formik: FormikProps<any>;
  sumOfSelectedTransactions: number;
  isUk?: boolean;
  onClickConfirm: () => void;
  onClickCancel: () => void;
};

export const SummaryStep = ({
  formik,
  sumOfSelectedTransactions,
  isUk,
  onClickConfirm,
  onClickCancel,
}: Props) => {
  const sumOfTransactions = Big(sumOfSelectedTransactions).round(8);
  return (
    <div style={{ marginTop: "50px" }}>
      <Row>
        <Col className={style.mainLabel}>
          <Typography.Title level={5}>Summary</Typography.Title>
        </Col>
      </Row>

      <div className={style.summarySection}>
        <div className={style.summarySectionTitle}>
          Timelock amount requested
        </div>
        <div className={style.summarySectionValue}>
          {Number(sumOfTransactions)} Staked_ETH
        </div>
      </div>

      <div className={style.summarySection}>
        <div className={style.summarySectionTitle}>Timelock</div>
        <div className={style.summarySectionValue}>
          {formik.values.timelockDuration !== null
            ? mappedTimeLockOptions.find(
              (x) => x.timelockDuration === formik.values.timelockDuration
            )?.title
            : ""}
        </div>
      </div>

      <Form.Item
        required
        hasFeedback
        help={formik.touched.agreement1 ? formik.errors.agreement1 : false}
        className={style.label}
      >
        <div className={style.checkboxWraper}>
          <Checkbox
            {...formik.getFieldProps("agreement1")}
            checked={formik.values.agreement1}
            id="agreement1"
          >
            <Typography.Text>
              <label htmlFor="agreement1" className={style.label}>
                I confirm that I have carefully read and fully understood the{" "}
                <a href="/terms_and_conditions/staking" target="_blank">
                  BF Staking Terms
                </a>{" "}
                including the terms of Figment, and I am aware of the potential
                risks invloved with staking.
              </label>
            </Typography.Text>
          </Checkbox>
        </div>
      </Form.Item>

      <Space direction="horizontal" className={style.footer}>
        <CustomBtn
          myType="cancel"
          onClick={onClickCancel}
          className={style.button}
        >
          Cancel
        </CustomBtn>

        <CustomBtn
          myType="submit"
          disabled={!formik.values.agreement1}
          onClick={onClickConfirm}
          className={style.button}
        >
          Confirm
        </CustomBtn>
      </Space>
    </div>
  );
};
